import React from "react";
import "./Page.css";

export function Page({ component: Component = "div", className, ...props }) {
  return <Component {...props} className={`Page ${className || ""}`} />;
}

export default Page;
